/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { GlobalSideNavigation } from '@atlassian/global-side-navigation';
import type { SidebarId } from '@atlassian/jira-route-types/src/Navigation.tsx';
import { SidebarSelector } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebar-selector/src/ui/regular/index.tsx';

type Props = {
	sidebarId: SidebarId;
	customizationStore?: React.ComponentProps<typeof GlobalSideNavigation>['customizationStore'];
	networkStorageParams?: React.ComponentProps<typeof GlobalSideNavigation>['networkStorageParams'];
};

export function GSNForOtherSidebars(props: Props): React.JSX.Element | null {
	const { customizationStore, networkStorageParams } = props;
	return (
		<GlobalSideNavigation
			app="jira"
			appLabel="Jira"
			customizationStore={customizationStore}
			networkStorageParams={networkStorageParams}
			disableMenuCustomization
			forYou={{}}
			items={{}}
			testId="nav-platform-integration-sidebar.ui.jira-other-sidebars"
			postMainElem={
				<div css={[styles.root]}>
					<SidebarSelector />
				</div>
			}
		/>
	);
}

const styles = cssMap({
	root: {
		marginTop: token('space.negative.150'),
		marginRight: token('space.negative.150'),
		marginBottom: token('space.negative.150'),
		marginLeft: token('space.negative.150'),
	},
});
